import angular from 'angular'
import _assign from 'lodash/assign'
import _get from 'lodash/get'
import { REHYDRATE } from 'redux-persist/constants'
import toGraphData from '../../services/timeline/timeline'

export default quotationReducer

const INITIAL_STATE = {
    viewState: 'state-form-initial',
    contractDraft: {},
    landscapeContractDraft: {},
    landscapeQuestions: {},
    tariffOptions: {},
    isLandscapeDone: false,
    isMobileIntroVisible: true,
    consumptionView: {
        isPostCodeIneligible: false,
        postCodeValidation: {},
        consumptionForm: {
            declaredAnnualCons: {},
            factorCons: 0,
            power: 6,
            calendar: 'BASE',
            postcode: null,
            citycode: null,
        },
    },
    quotationView: {
        quotationResult: null,
        quotationError: null,
        graphTimetable: [],
        potResult: {
            reduction: null,
            pot: null,
            total: null,
        },
    },
    timetableView: {
        sleek_timetable: false,
        tutorial: {
            display: false,
            state: 'state-1',
            sleek_timetable: false,
            isSummer: false,
            isWinter: false,
            isNextReading: false,
        },
    },
    potView: {
        viewState: 'state-form',
        isUpdating: false,
        error: null,
    },
    resultPotView: {
        viewState: 'state-initial',
    },
    visitorView: {
        viewState: 'state-initial',
    },
}

function viewStateReducer(state, action) {
    switch (action.type) {
        case 'GO_TO_INITIAL':
            return 'state-form-initial'
        case 'GO_TO_FORM_LANDSCAPE':
            return 'state-form-landscape'
        case 'GO_TO_FORM_CONSUMPTION':
            return 'state-form-consumption'
        case 'GO_TO_STATE_RESULT':
            return 'state-result'
        case 'GO_TO_STATE_TIMETABLE':
            return 'state-timetable'
        case 'GO_TO_STATE_POT':
            return 'state-pot'
        case 'GO_TO_STATE_VISITOR':
            return 'state-visitor'
        case 'GET_QUOTATION':
            return 'state-result-loading'
        case 'GET_QUOTATION_DONE':
            return 'state-result'
        case 'GET_QUOTATION_ERROR':
            return 'state-result-error'
        case 'INIT_VIEW_STATE':
            return action.viewState
        default:
            return state
    }
}

function consumptionViewReducer(state, action) {
    switch (action.type) {
        case 'VALIDATE_POST_CODE':
            return _assign({}, state, {
                postCodeValidation: { state: 'PENDING', choosen_post_code: action.choosen_post_code },
            })
        case 'VALIDATE_POST_CODE_DONE':
            return _assign({}, state, {
                isPostCodeIneligible: action.postCodeResult.exist && !action.postCodeResult.eligible,
                postCodeValidation: _assign({}, action.postCodeResult, {
                    state: 'DONE',
                    choosen_post_code: action.choosen_post_code,
                }),
            })
        case 'VALIDATE_POST_CODE_FAIL':
            return _assign({}, state, {
                postCodeValidation: {
                    state: 'FAIL',
                    choosen_post_code: action.choosen_post_code,
                    error: action.error,
                },
            })
        case 'VALIDATE_POST_CODE_INITIAL':
            return _assign({}, state, {
                isPostCodeIneligible: false,
                postCodeValidation: {},
            })
        case 'UPDATE_FORM_CONSUMPTION':
            return _assign({}, state, {
                consumptionForm: _assign({}, action.consumptionForm, { factorCons: 0 }),
            })
        case 'UPDATE_QUOTATION_POT':
            return _assign({}, state, {
                consumptionForm: _assign({}, state.consumptionForm, { factorCons: action.factorCons }),
            })
        default:
            return state
    }
}

function quotationViewReducer(state, action) {
    switch (action.type) {
        case 'UPDATE_FORM_CONSUMPTION':
        case 'GET_QUOTATION':
            return _assign({}, state, {
                quotationResult: null,
                quotationError: null,
                graphTimetable: [],
                potResult: {
                    reduction: null,
                    pot: null,
                    total: null,
                },
            })
        case 'GET_QUOTATION_DONE':
            return _assign({}, state, {
                quotationResult: _assign({}, action.quotationResult),
                graphTimetable: toGraphData(action.quotationResult.timetable),
            })
        case 'GET_QUOTATION_ERROR':
            return _assign({}, state, {
                quotationError: action.error,
            })
        case 'UPDATE_QUOTATION_POT':
            return _assign({}, state, {
                potResult: {
                    reduction: null,
                    pot: null,
                    total: null,
                },
            })
        case 'UPDATE_QUOTATION_POT_DONE':
            return _assign({}, state, {
                quotationResult: _assign({}, state.quotationResult, { pot: action.pot }),
                potResult: {
                    reduction: action.pot.total.normal - action.pot.total.factored,
                    pot: action.pot.pot,
                    total: (action.pot.total.normal - action.pot.total.factored) + action.pot.pot,
                },
            })
        default:
            return state
    }
}

function timetableViewReducer(state, action) {
    switch (action.type) {
        case 'GO_TO_STATE_TIMETABLE':
            return _assign({}, state, {
                tutorial: {
                    display: false,
                    state: 'state-1',
                    sleek_timetable: false,
                    isSummer: false,
                    isWinter: false,
                    isNextReading: false,
                },
            })
        case 'UPDATE_SLEEK_TIMETABLE':
            return _assign({}, state, {
                sleek_timetable: action.sleek_timetable,
            })
        case 'TIMETABLE_VIEW_TUTORIAL_CLOSE':
            return _assign({}, state, {
                tutorial: _assign({}, state.tutorial, {
                    display: false,
                    state: 'state-1',
                    sleek_timetable: false,
                    isSummer: false,
                    isWinter: false,
                    isNextReading: false,
                }),
            })
        case 'TIMETABLE_VIEW_TUTORIAL_NEXT': {
            let tutorial
            if (state.tutorial.display === false) {
                tutorial = {
                    display: true,
                    state: 'state-1',
                    sleek_timetable: false,
                    seasonClass: 'summer',
                    isSummer: true,
                    isWinter: false,
                    isNextReading: false,
                }
            } else if (state.tutorial.state === 'state-1') {
                tutorial = {
                    display: true,
                    state: 'state-2',
                    sleek_timetable: false,
                    seasonClass: 'winter',
                    isSummer: false,
                    isWinter: true,
                    isNextReading: false,
                }
            } else if (state.tutorial.state === 'state-2') {
                tutorial = {
                    display: true,
                    state: 'state-3',
                    sleek_timetable: true,
                    isSummer: false,
                    isWinter: false,
                    isNextReading: false,
                }
            } else if (state.tutorial.state === 'state-3') {
                tutorial = {
                    display: false,
                    state: 'state-1',
                    sleek_timetable: false,
                    isSummer: false,
                    isWinter: false,
                    isNextReading: false,
                }
            } else {
                tutorial = {
                    display: false,
                    state: 'state-1',
                    sleek_timetable: false,
                    isSummer: false,
                    isWinter: false,
                    isNextReading: false,
                }
            }
            return _assign({}, state, {
                tutorial: _assign({}, state.tutorial, tutorial),
            })
        }
        default:
            return state
    }
}

function potViewReducer(state, action) {
    switch (action.type) {
        case 'GO_TO_STATE_POT':
            return _assign({}, state, {
                viewState: 'state-form',
            })
        case 'UPDATE_FORM_CONSUMPTION':
            return _assign({}, state, {
                viewState: 'state-form',
                isUpdating: false,
                error: null,
            })
        case 'UPDATE_QUOTATION_POT':
            return _assign({}, state, {
                isUpdating: true,
            })
        case 'UPDATE_QUOTATION_POT_DONE':
            return _assign({}, state, {
                viewState: 'state-result',
                isUpdating: false,
            })
        case 'UPDATE_QUOTATION_POT_ERROR':
            return _assign({}, state, {
                isUpdating: false,
                error: action.error,
            })
        default:
            return state
    }
}

function resultPotViewReducer(state, action) {
    switch (action.type) {
        case 'OPEN_RESULT_POT_DETAIL':
            return _assign({}, state, { viewState: 'state-detail' })
        default:
            return state
    }
}

function visitorViewReducer(state, action) {
    switch (action.type) {
        case 'GO_TO_STATE_VISITOR':
            return _assign({}, state, { viewState: 'state-initial' })
        case 'DISPLAY_NEWSLETTER_FORM':
            return _assign({}, state, { viewState: 'state-form', isSubmitting: false })
        case 'SUBMIT_NEWSLETTER_FORM':
            return _assign({}, state, { viewState: 'state-form', isSubmitting: true })
        case 'SUBMIT_NEWSLETTER_FORM_DONE':
            return _assign({}, state, { viewState: 'state-success', isSubmitting: false })
        case 'SUBMIT_NEWSLETTER_FORM_ERROR':
            return _assign({}, state, { viewState: 'state-form', isSubmitting: false })
        case 'DISPLAY_FIRST_ADVICE':
            return _assign({}, state, { viewState: 'state-first-advice' })
        default:
            return state
    }
}

function commonReducer(state, action) {
    switch (action.type) {
        case 'HIDE_MOBILE_INTRO':
            return _assign({}, state, { isMobileIntroVisible: false })
        case 'ON_CHANGES_CONTRACT_DRAFT':
            return _assign({}, state, {
                contractDraft: angular.copy(action.contractDraft.currentValue),
                landscapeContractDraft: { id: _get(action, 'contractDraft.currentValue.id'), isDraft: true },
            })
        case 'ON_CHANGES_LANDSCAPE_QUESTIONS':
            return _assign({}, state, { landscapeQuestions: angular.copy(action.landscapeQuestions.currentValue) })
        case 'ON_CHANGES_TARIFF_OPTIONS':
            return _assign({}, state, { tariffOptions: angular.copy(action.tariffOptions.currentValue) })
        case 'LANDSCAPE_DONE':
            return _assign({}, state, { isLandscapeDone: action.isLandscapeDone })
        default:
            return state
    }
}

function quotationReducer(state = INITIAL_STATE, action) {
    if (action.type === 'RESET_QUOTATION') {
        return _assign({}, state, INITIAL_STATE)
    }
    if (action.type === REHYDRATE) {
        // Reload state from localstorage using redux-persist
        // Avoid to erase rehydrate state
        return state
    }
    return _assign({}, commonReducer(state, action), {
        viewState: viewStateReducer(state.viewState, action),
        quotationView: quotationViewReducer(state.quotationView, action),
        consumptionView: consumptionViewReducer(state.consumptionView, action),
        timetableView: timetableViewReducer(state.timetableView, action),
        potView: potViewReducer(state.potView, action),
        resultPotView: resultPotViewReducer(state.resultPotView, action),
        visitorView: visitorViewReducer(state.visitorView, action),
    })
}



// WEBPACK FOOTER //
// ./src/states/quotation/quotation.reducer.js